var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserMultipleGroup = function SvgUserMultipleGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 6.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M.5 13.5h9v-.542A4.51 4.51 0 0 0 4.796 8.5 4.51 4.51 0 0 0 .5 12.958zM9 6.5a2.5 2.5 0 0 0 0-5M11.5 13.5h2v-.542A4.51 4.51 0 0 0 10 8.609"
  }))));
};
export default SvgUserMultipleGroup;